module.exports = __webpack_public_path__ + "static/img/adaptivity.bdd52df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/NBA2K20/top/adaptivity.jpg
// module id = hgqq
// module chunks = 0